"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("../Box"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("../../theme"));

var _styledSystem = require("styled-system");

var _util = require("../../theme/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconButtonStyle = (0, _styledSystem.variant)({
  key: "iconbuttons"
});
var IconButtonEl = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "IconButton__IconButtonEl",
  componentId: "sc-12njjcg-0"
})(["outline:none;border-radius:100px;padding:6px;border:none;display:inline-flex;justify-content:center;font-size:24px;line-height:24px;background-color:transparent;transition:background-color 250ms ", ",color 250ms ", ";cursor:pointer;&:disabled{cursor:not-allowed;pointer-events:none;opacity:0.5;}", " ", " ", " ", " ", " ", "{font-size:inherit;color:inherit;line-height:inherit;}"], _util.transition, _util.transition, function (props) {
  return props.theme["IconButton"];
}, iconButtonStyle, _styledSystem.color, _styledSystem.fontSize, _styledSystem.lineHeight, _Icon["default"]);

var IconButton = _react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react["default"].createElement(IconButtonEl, _extends({
    ref: ref
  }, props), _react["default"].createElement(_Icon["default"], null, children));
});

IconButton.propTypes = _objectSpread({}, _Box["default"].propTypes, {}, _styledSystem.color.propTypes, {}, _styledSystem.fontSize.propTypes, {}, _styledSystem.lineHeight.propTypes, {
  onClick: _propTypes["default"].func
});
IconButton.defaultProps = {
  theme: _theme["default"],
  as: 'button',
  variant: 'default',
  onClick: function onClick() {}
};
var _default = IconButton;
exports["default"] = _default;